<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-single-item-page">
    <tl-header></tl-header>
    <div class="wrapper-content-single-page">
      <div class="header-single-page-item">
        <div class="background-color-single-item" [ngStyle]="{'background-image': 'url(' + (item && item.images[0]?.url !== null ? item.images[0]?.url : 'assets/images/no-image.png') + ')'}"></div>
      </div>
      <div class="content-single-item-page">
        <div class="wrapper-image-name-item">
          <div class="wrapper-image-item-single-view">
            <div *ngFor="let image of item?.images | slice:0:3" class="image">
              <img [src]="image.url" alt="" (click)="selectedMedia = image">
              <div *ngIf="loggedUser.id === item.lyst.user_id" (click)="deleteImage(image)" class="delete-image-item">
                <img src="../../../assets/icons/outline/icon-delete.svg" alt="">
              </div>
            </div>
            <div *ngIf="item !== undefined && item.images.length < 3 && loggedUser.id === item.lyst.user_id" class="wrapper-add-image-item">
              <label class="add-image-item">
                <img (click)="triggerFileInput($event)" src="../../../assets/icons/outline/icon-plus.svg" alt="">
                <input #fileInput type="file" accept=".jpg, .jpeg, .png, .svg" (change)="onFileChange($event)">
              </label>
            </div>
          </div>
          <span *ngIf="item">{{item.name}}</span>
        </div>
        <div class="wrapper-likes-and-more-btn" [ngClass]="{'tl-justify-end': item && ((item.lyst.user.subscriptions | checkActiveRole) !== UserRoles.expert || (item.lyst.user.subscriptions | checkActiveRole) !== UserRoles.company)}">
          <div *ngIf="item && ((item.lyst.user.subscriptions | checkActiveRole) === UserRoles.expert || (item.lyst.user.subscriptions | checkActiveRole) === UserRoles.company)" class="wrapper-like-rating-single-item">
            <div class="wrapper-likes">
              <button (click)="additemToFavorites()" class="custom-btn custom-btn--circle-outline">
                <img *ngIf="!item?.am_i_favorite_this_lyst_item" class="no-like"
                  src="../../../../assets/icons/outline/icon-heart.svg" alt="">
                <img *ngIf="item?.am_i_favorite_this_lyst_item" class="like"
                  src="../../../../assets/icons/fill/icon-heart.svg" alt="">
              </button>
              <span [routerLink]="[PAGES_AND_PATHS.listLikes.pagePath, item.id, 'item']">{{item.favorite_users_count}}
                {{item.favorite_users_count === 1 ? ('LISTS.like' | translate ): ('LISTS.likes' | translate)}}</span>
            </div>
            <span class="vertical-line"></span>
            <app-item-rating [averageRating]="item.average_rating"
              [reviewsCount]="item.reviews_count"></app-item-rating>
          </div>
          <div class="wrapper-dropdown-btn" appClickedOutside (clickedOutside)="isViewMoreModalOpen = false">
            <button (click)="openDropdown($event)" class="custom-btn custom-btn--circle-outline">
              <img src="../../../../assets/icons/outline/icon-view-more.svg" alt="">
            </button>
            <div *ngIf="isViewMoreModalOpen" class="content-dropdown-btn">
              <div (click)="isShareProfileModalOpen = true" class="item-dropdown">
                <img src="../../../../assets/icons/outline/icon-share.svg" alt="">
                <span>
                  {{'GENERAL.share' | translate}}
                </span>
              </div>
              <div (click)="reportItem()" class="item-dropdown delete">
                <img src="../../../../assets/icons/outline/icon-outline-attention.svg" alt="">
                <span>
                  {{'LIST_SINGLE_PAGE.report' | translate}}
                </span>
              </div>
              <div *ngIf="loggedUser.id === item?.lyst?.user_id" (click)="openDeleteModal()"
                class="item-dropdown delete">
                <img src="../../../../assets/icons/outline/icon-delete.svg" alt="">
                <span>
                  {{'ITEMS.delete_item' | translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper-custom-tabs">
          <div class="custom-tab" [ngClass]="{'active': tabSelected === 'info'}" (click)="selectTab('info')">
            <img src="../../../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'ITEMS.info' | translate}}
            </span>
          </div>
          <div class="custom-tab" [ngClass]="{'active': tabSelected === 'posts'}" (click)="selectTab('posts')">
            <img src="../../../../../assets/icons/outline/icon-posts.svg" alt="">
            <span>
              {{'GENERAL.posts' | translate}}
            </span>
          </div>
          <div *ngIf="((item?.lyst?.user?.subscriptions | checkActiveRole) == UserRoles.expert || (item?.lyst?.user?.subscriptions | checkActiveRole) == UserRoles.company)" class="custom-tab" [ngClass]="{'active': tabSelected === 'reviews'}" (click)="selectTab('reviews')">
            <img src="../../../../assets/icons/outline/icon-review.svg" alt="">
            <span>
              {{'GENERAL.reviews' | translate}}
            </span>
          </div>
        </div>
        <app-info *ngIf="tabSelected === 'info'" [item]="item"></app-info>
        <app-posts *ngIf="tabSelected === 'posts'" [item]="item" [list]="item.lyst" [id]="itemId" [isList]="false"></app-posts>
        <app-reviews *ngIf="tabSelected === 'reviews'" [reviewObj]="item" [isList]="false" (refreshSinglePage)="getSingleItem()"></app-reviews>
      </div>
    </div>
  </div>
</div>
<tl-sharing-options-modal *ngIf="isShareProfileModalOpen"
                          [entityType]="ShareEntitiesEnums.lyst_item"
                          [entityId]="itemId"
                          [urlForShare]="itemUrl"
                          (closeModal)="isShareProfileModalOpen = false;
                          isViewMoreModalOpen = false;">
</tl-sharing-options-modal>
<tl-confirm-modal *ngIf="isDeleteModalOpen"
                  [modalIcon]="'../../../../../assets/icons/outline/icon-delete.svg'"
                  [modalTitle]="modalText.title"
                  [confirmBtnText]="modalText.button"
                  [modalDescription]="modalText.description"
                  (cancelModal)="isDeleteModalOpen = false"
                  (confirmModal)="deleteItem()">
</tl-confirm-modal>
<app-report-modal *ngIf="isReportModalOpen"
                  [entityId]="item.id" [entityType]="'item'"
                  (closeModal)="isReportModalOpen = false"
                  (reportSent)="isReportModalOpen = false">
</app-report-modal>
<app-preview-media *ngIf="selectedMedia !== null"
                   [photoPreview]="true"
                   [selectedMedia]="selectedMedia"
                   (closeModal)="selectedMedia = null">
</app-preview-media>
